import { render } from "./BigNumber.vue?vue&type=template&id=5b4dc78c&scoped=true"
import script from "./BigNumber.vue?vue&type=script&lang=js"
export * from "./BigNumber.vue?vue&type=script&lang=js"

import "./BigNumber.vue?vue&type=style&index=0&id=5b4dc78c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b4dc78c"]])

export default __exports__